import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils/buildUrl";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import { IClauseType } from "./clause-types.types";
const API = `${API_URL}/clause-types`;

export const getClauseTypes = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter
) => {
    const url = buildUrl(API, { page, size, ...filter });
    const result = await axios.get<Page<IClauseType>>(url);
    return result.data;
};
